import { render, staticRenderFns } from "./Mountains.vue?vue&type=template&id=f01a69d4&scoped=true"
import script from "./Mountains.vue?vue&type=script&lang=js"
export * from "./Mountains.vue?vue&type=script&lang=js"
import style0 from "./Mountains.vue?vue&type=style&index=0&id=f01a69d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01a69d4",
  null
  
)

export default component.exports